module.exports = __webpack_public_path__ + "static/media/placeholder.b2f9abf6.jpg";